(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Expandabe-Image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const expandButton = document.querySelector('.expand-button');
  const overlay = document.querySelector('.overlay');
  const moreInfo = document.querySelector('.more-info');

  expandButton.addEventListener('click', function () {
  overlay.classList.toggle('expanded');
  moreInfo.style.display = overlay.classList.contains('expanded') ? 'block' : 'none';
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["impact-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const quantitySelector = document.querySelector('.quantity-selector-impact');
    const priceDisplay = document.querySelector('.price');
    const co2Display = document.querySelector('.co2');

    quantitySelector.addEventListener('change', updateDetails);

    function updateDetails() {
      const selectedQuantity = parseInt(quantitySelector.value);
      const basePrice = 0.045;

      const totalPrice = basePrice * selectedQuantity;
      let totalCO2 = 0.041 * selectedQuantity;

      if (totalCO2 > 1000) {
        totalCO2 = (totalCO2 / 1000).toFixed(1);
        co2Display.textContent = totalCO2 + ' t';
      } else {
        co2Display.textContent = totalCO2.toFixed(1) + ' kg';
      }

      priceDisplay.textContent = totalPrice.toFixed(2) + ' €';
    }

    updateDetails();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pie-chart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
   var xValues = ["Green Coffee", "Roasting", "Packaging", "Transport", "Reforestaration", "Operations", "Sales", "Logistics"];
      var yValues = [35, 6.5, 2, 8.5, 1, 28, 15, 4];
      var barColors = [
        "#295237",
        "#367E4C",
        "#4A9D62",
        "#6EBA84",
        "#4A9D62",
        "#EFEDED",
        "#D9D9D9",
        "#EFEDED"
      ];
      new Chart("myChart", {
        type: "doughnut",
        data: {
          labels: xValues,
          datasets: [{
            backgroundColor: barColors,
            data: yValues
          }]
        },
        options: {
          legend: {
            display: false
          },
  responsive: false,
          title: {
            display: true,
            text: ""
          }
        },
      hoverOffset: 10
      });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["podcast-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      const section = document.getElementById('expandableSection');
      const moreButton = document.getElementById('moreButton');
      let visibleBoxes = 3;

      moreButton.addEventListener('click', function() {
          visibleBoxes += 3;
          showHideBoxes();
      });

      function showHideBoxes() {
          const boxes = section.querySelectorAll('.podcast-card');
          boxes.forEach((box, index) => {
              if (index < visibleBoxes) {
                  box.style.display = 'flex';
              } else {
                  box.style.display = 'none';
              }
          });

          if (visibleBoxes >= boxes.length) {
              moreButton.style.display = 'none';
          } else {
              moreButton.style.display = 'flex';
          }
      }

      showHideBoxes();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
      const customTabButtons = document.querySelectorAll('.custom-tab-button');
      const customTabContents = document.querySelectorAll('.custom-tab-content');

      customTabButtons.forEach(button => {
        button.addEventListener('click', () => {
          customTabButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');

          const targetCustomTab = button.getAttribute('data-custom-tab');
          customTabContents.forEach(content => {
            content.style.display = 'none';
          });
          document.getElementById(targetCustomTab).style.display = 'block';
        });
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var video = document.querySelector("video");
    var playPauseButton = document.getElementById("play-pause-button");

    playPauseButton.addEventListener("click", function() {
      if (video.paused) {
        video.play();
        playPauseButton.classList.add("playing");
      } else {
        video.pause();
        playPauseButton.classList.remove("playing");
      }
    });

    video.addEventListener("pause", function() {
      playPauseButton.classList.remove("playing");
    });

    video.addEventListener("play", function() {
      playPauseButton.classList.add("playing");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
